<template>
  <div class="dialog-form">
    <div class="dialog-form-body">
      <el-form ref="form" :model="detail" label-width="100px">
        <el-form-item :required="true" label="所属平台">
          <el-radio-group v-model="detail.type" @change="handlerChange">
            <el-radio :label="1">多多账号</el-radio>
            <el-radio :label="2">巴巴账号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :required="true" label="自动采购" v-if="detail.type==2">
          <el-radio-group v-model="detail.alibaba_auto_purchase" @change="handlerAlibabaAutoPurchase">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item :required="true" label="自动售后">
          <el-radio-group v-model="detail.auto_deal_dd_after_sales">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="延迟采购时间" v-if="detail.type==2">
          <el-input-number v-model="detail.alibaba_auto_purchase_delay" :min="0" :precision="0" placeholder="请输入"></el-input-number>
          <span class="unit">秒</span>
          <p class="red"><i class="iconfont el-icon-warning"></i> 开启自动采购后，延迟指定秒数再下单</p>
        </el-form-item>
        <el-form-item label="店铺分组">
          <el-select size="small" v-model="detail.group_ids" multiple collapse-tags clearable  placeholder="请选择分组">
            <el-option v-for="item in filter_groupList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :required="true" label="手机号">
          <el-input v-model="detail.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="detail.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="支付宝账号" v-if="detail.type === 1">
          <el-input v-model="detail.alipay_account" placeholder="请输入支付宝账号"></el-input>
        </el-form-item>
        <el-form-item label="支付宝密码" v-if="detail.type === 1">
          <el-input v-model="detail.alipay_password" placeholder="请输入支付宝密码"></el-input>
        </el-form-item>
        <!--				<el-form-item label="开启免密支付" v-if="detail.type === 2">-->
        <!--					<el-switch-->
        <!--						v-model="detail.is_without_code_pay"-->
        <!--						active-color="#13ce66"-->
        <!--						inactive-color="#DDDDDD"-->
        <!--						@change="handlerSwitchChange"-->
        <!--					>-->
        <!--					</el-switch>-->
        <!--				</el-form-item>-->
        <el-form-item label="利润差">
          <el-input-number v-model="detail.profit_margin" placeholder="请输入"></el-input-number>
          <p class="red"><i class="iconfont el-icon-warning"></i> 利润低于N元不采购</p>
        </el-form-item>
        <template v-if="detail.type==2">
          <el-form-item label="运费风控" class="shipping-risk-item">
            <div class="shipping-risk" style="display:flex;flex-direction:column;gap:12px;">
              <div class="shipping-risk-row">
                <el-checkbox
                    v-model="detail.shipping_risk_fee_enable"
                    :true-label="1"
                    :false-label="0"
                >当代发费 ≥</el-checkbox>
                <el-input-number
                    v-model="detail.shipping_risk_fee_amount"
                    size="mini"
                    :min="0"
                    :precision="2"
                    :controls="false"
                    placeholder="N"
                ></el-input-number>
                <span class="shipping-risk-text">元时，仅下单不付款</span>
              </div>
              <div class="shipping-risk-row">
                <el-checkbox
                    v-model="detail.shipping_risk_ratio_enable"
                    :true-label="1"
                    :false-label="0"
                >当代发费 ÷</el-checkbox>
                <el-select
                    v-model="detail.shipping_risk_ratio_base"
                    size="mini"
                    placeholder="请选择"
                    style="width: 140px;"
                >
                  <el-option label="抖店子订单金额" value="dd_order"></el-option>
                  <el-option label="采购商品金额" value="purchase_goods"></el-option>
                </el-select>
                <span class="shipping-risk-text">≥</span>
                <el-input-number
                    v-model="detail.shipping_risk_ratio_percent"
                    size="mini"
                    :min="0"
                    :precision="2"
                    :controls="false"
                    placeholder="n"
                ></el-input-number>
                <span class="shipping-risk-text">% 时，仅下单不付款</span>
              </div>
            </div>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div class="dialog-form-footer">
      <el-button class="default" @click="handlerCancel">取消</el-button>
      <el-button class="primary" @click="handlerSubmit">确定</el-button>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

const DEFAULT_PAYLOAD = {
  type: null,
  phone: null,
  name: null,
  groupids: null,
  alibaba_auto_purchase: null,
  alibaba_auto_purchase_delay: 0,
  // auto_deal_dd_after_sales: 1,
  alipay_account: null,
  alipay_password: null,
  profit_margin: null,
  is_without_code_pay: null,
  shipping_risk_fee_enable: 0,
  shipping_risk_fee_amount: 0,
  shipping_risk_ratio_enable: 0,
  shipping_risk_ratio_base: 'dd_order',
  shipping_risk_ratio_percent: 0,
}

export default {
  props:{
    detail:{
      type:Object,
      default(){
        return DEFAULT_PAYLOAD
      }
    },
    groupList:{
      type:Array,
      default(){
        return []
      }
    },
    allocatedGroupIds:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data(){
    return {
      filter_groupList:[],
    }
  },
  created(){
    this.finalGroupList()
  },
  methods:{
    ...mapActions({
      opPddAccountList: "ucenter_order/opPddAccountList",
      opCheckIsOpenProtocolPay: "ucenter_order/opCheckIsOpenProtocolPay",
    }),
    handlerSubmit(){
      const data = this.detail;
      this.$emit('confirm', data)
    },
    handlerCancel(){
      this.$emit('cancel')
    },
    handlerChange(val){
      if(val === 1){
        this.detail.profit_margin = 0.5
      }else{
        this.detail.profit_margin = 0.3
        if(this.detail.alibaba_auto_purchase == null){
          this.detail.alibaba_auto_purchase = 0
        }
        if(this.detail.alibaba_auto_purchase_delay == null){
          this.detail.alibaba_auto_purchase_delay = 0
        }
        if(this.detail.shipping_risk_fee_enable == null){
          this.detail.shipping_risk_fee_enable = 0
        }
        if(this.detail.shipping_risk_fee_amount == null){
          this.detail.shipping_risk_fee_amount = 0
        }
        if(this.detail.shipping_risk_ratio_enable == null){
          this.detail.shipping_risk_ratio_enable = 0
        }
        if(!this.detail.shipping_risk_ratio_base){
          this.detail.shipping_risk_ratio_base = 'dd_order'
        }
        if(this.detail.shipping_risk_ratio_percent == null){
          this.detail.shipping_risk_ratio_percent = 0
        }
      }
      // if(this.detail.auto_deal_dd_after_sales == null){
      // 	this.detail.auto_deal_dd_after_sales = 1
      // }
    },
    handlerAlibabaAutoPurchase(val){
      if(val === 1){
        this.detail.alibaba_auto_purchase = 1
      }else{
        this.detail.alibaba_auto_purchase = 0
      }
    },
    handlerSwitchChange(val) {
      console.log(val)
      if (val) {
        if (!this.detail.id) {
          this.$message.error('请先创建账号，再来启用免密支付');
          this.detail.is_without_code_pay = false;
          return false;
        }
        this.opCheckIsOpenProtocolPay({
          data: {
            id: this.detail.id
          },
          success: (res) => {
            console.log(res);
            if (res.code !== 200) {
              this.detail.is_without_code_pay = false;
              this.$message.error(res.msg);
            }else{
              if (res.data.signedStatus && res.data.bindingStatus) {
                this.$message.success('该账号已开通免密支付');
              }else{
                this.detail.is_without_code_pay = false;
                this.$message.error('该账号未开通免密支付', {duration: 2000});
                setTimeout(() => {
                  window.open(res.data.signUrl);
                }, 2000);

              }
            }
          }
        })

      }
    },
    finalGroupList() {
      const detailIds = this.detail?.group_ids ?? []
      const allocatedIds = this.allocatedGroupIds ?? []
      const list = this.groupList ?? []
      // 规则：
      // 先排除 allocatedIds，但 detailIds 必须保留
      this.filter_groupList = list.filter(item => {
        const id = item.id
        if (detailIds.includes(id)) return true
        if (allocatedIds.includes(id)) return false
        return true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-form{
  &-body{
    .el-form{
      &-item{
        &__label{
          font-size: 14px;
          color: #666666;
        }
      }
      .el-select{
        width: 290px;
      }
      .el-input{
        width: 290px;
      }
      .unit{
        margin-left: 8px;
        font-size: 14px;
        color: #666666;
      }
      .red{
        margin-top: 6px;
        font-size: 12px;
        line-height: 1.4;
        color: #f0413e;
      }
      :deep(.shipping-risk-item){
        .el-form-item__content{
          line-height: normal;
        }
      }
      .shipping-risk{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 12px;
        &-row{
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 4px 6px;
          line-height: 28px;
          .el-input-number{
            width: 88px;
          }
          :deep(.el-input__inner){
            height: 28px;
            line-height: 28px;
          }
          :deep(.el-input-number.is-without-controls .el-input__inner){
            padding-left: 8px;
            padding-right: 8px;
          }
        }
        &-text{
          font-size: 13px;
          color: #666666;
          white-space: nowrap;
        }
      }
    }
    &-tips{
      margin-top: 40px;
      font-size: 12px;
      line-height: 24px;
      color: #f0413e;
    }
  }
  &-footer{
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .el-button{
      width: 90px;
      height: 35px;
      padding: 0;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 1px #dddddd;
      color: #333333;
      font-size: 12px;
      &.default{
        background-color: #ffffff;
      }
      &.primary{
        color: #fff;
        background-color: #f0413e;
        border-color: #f0413e;
      }
    }
  }
}
</style>
